import Config from "@/vuex/Config";

let DAODiamondExchange = function () {

    this.getList = function (country, carat, color, finish, polish, purity, form, symmetry, fluorescence, certificateNo, certificate, stoneIds, stoneType, navSite, navLimit) {
        return new Promise((resolve) => {
            let url = Config.getters.getDiamondStockUrl + "/Designer/diamondsGetData.php";

            if (typeof carat != 'string' || carat === '') {
                carat = '0.28';
            }

            if (typeof color != 'string' || color === '') {
                color = '6_id';
            }

            if (typeof finish != 'string' || finish === '') {
                finish = '1_id';
            }

            if (typeof polish != 'string' || polish === '') {
                polish = '1_id';
            }

            if (typeof purity != 'string' || purity === '') {
                purity = '1_id';
            }

            if (typeof form != 'string' || form === '') {
                form = 'A';
            }

            if (typeof symmetry != 'string' || symmetry === '') {
                symmetry = '5_id';
            }

            if (typeof fluorescence != 'string' || fluorescence === '') {
                fluorescence = '6_id';
            }

            if (typeof certificate != 'string' || certificate === '') {
                certificate = '1-2-3';
            }

            if (typeof certificateNo != 'string' || certificateNo === '') {
                certificateNo = '';
            }

            if (typeof stoneIds !== 'object' || stoneIds.length < 0) {
                stoneIds = false;
            }

            if (typeof navSite != 'number' || navSite === '') {
                navSite = 1;
            }
            navSite--;

            if (typeof navLimit != 'number' || navLimit === '') {
                navLimit = 10;
            }

            if (stoneIds !== false) {
                stoneIds = JSON.stringify(stoneIds);
            }

            if (!parseInt(stoneType) > 0) {
                stoneType = 1;
            }

            let data = new FormData();
            data.append('navLimit', navLimit);
            data.append('navSite', navSite);
            data.append('code', country);
            data.append('ac', 'get_list');
            data.append('search', '{"price_select":{"from":"100","till":""},"carat_select":{"from":"' + carat + '","till":""},"color_select":{"from":"' + color + '","till":""},"finish_select":{"from":"' + finish + '","till":""},"polish_select":{"from":"' + polish + '","till":""},"symmetry_select":{"from":"' + symmetry + '","till":""},"purity_select":{"from":"' + purity + '","till":""},"fluorescence_select":{"from":"' + fluorescence + '","till":""},"stoneform_select":{"from":"' + form + '","till":"' + form + '"},"certificate":{"nr":"' + certificateNo + '"},"certificate_select":"' + certificate + '","stoneType":"' + stoneType + '","stoneIds": ' + stoneIds + '}');

            fetch(url, {
                method: 'post',
                body: data
            }).then(response => {
                response.json().then(json => {
                    if (typeof json.list == 'object') {
                        json.list = this.formatList(json.list);
                    }
                    resolve(json);
                });
            });
        });
    }

    this.formatList = (diamondList) => {
        for (let id in diamondList) {
            if (typeof diamondList[id].supplier == 'string') {
                // Fix Certificate (Dettinger)
                if (diamondList[id].supplier == '10010') {
                    let certNr = diamondList[id].certificateNr.trim();
                    let lastCharOfCertificate = certNr.substr(certNr.length - 1, certNr.length);

                    if (lastCharOfCertificate == 'D' || lastCharOfCertificate == 'd') {
                        diamondList[id].certificateNr = certNr.substr(0, certNr.length - 1);
                    }
                }

                // Last 2 chars of supplierId
                let supplierIdLength = diamondList[id].supplier.length;
                diamondList[id].supplierKey = diamondList[id].supplier.substr(supplierIdLength - 2, supplierIdLength);
            }
        }

        return diamondList;
    }

    this.addToItem = function (itemnumber, diamondId, groupId, stoneId) {
        return new Promise((resolve, reject) => {
            let url = Config.getters.getApiHostWithLocalStr + '/v2/items/add/diamond/' + diamondId + '/' + itemnumber + '/' + groupId + '/' + stoneId + '/';

            fetch(url, {
                method: 'get'
            }).then(response => {
                response.json().then(json => {
                    if (typeof json.status === "boolean") {
                        if (json.status === true) {
                            if (typeof json.result.itemnumber === "string") {
                                resolve(json.result.itemnumber, json.alerts);
                            }
                        } else {
                            reject(json.alerts);
                        }
                    } else {
                        reject(false);
                    }
                });
            });
        });
    }

    this.getItemnumber = function(diamondId) {
        return new Promise((resolve, reject) => {
            let url = Config.getters.getApiHostWithLocalStr + '/v2/items/get/diamond/' + diamondId + '/';

            fetch(url, {
                method: 'get'
            }).then(response => {
                response.json().then(json => {
                    if (typeof json.status === "boolean") {
                        if (json.status === true && json.result.itemnumber) {
                            resolve(json.result.itemnumber);
                        } else {
                            reject(json.alerts);
                        }
                    } else {
                        reject(false);
                    }
                });
            });
        });
    }
}

export default new DAODiamondExchange();